<template>
  <div class="cursor-pointer" @click="showBody = !showBody">
    <div class="flex items-center gap-2">
      <div class="text-sm">
        <div class="font-medium text-gray-900">Email - {{ email.subject || 'No subject' }}</div>
      </div>
    </div>
    <div>
      <div v-if="showBody" class="mt-1 text-sm text-gray-700 user-generated-content">
        <div v-html="sanitize(email.body)"></div>
      </div>
      <div class="mt-2 space-x-2 text-sm flex">
        <span class="font-medium text-gray-500"
          >{{ fromNow(email.created_at) }} ago from {{ email.user.name ? email.user.name : email.user.email }}</span
        >
        <Badge v-if="email.postmark_delivered_at" variant="blue">Delivered</Badge>
        <Badge v-if="email.postmark_bounced_at" variant="red">Bounced</Badge>
        <Badge v-if="email.postmark_received_at" variant="green">Opened</Badge>
      </div>
    </div>
  </div>
</template>

<script>
import { sanitizeRichText } from '../../utilities/sanitization.ts';
import DateUtility from '../../utilities/dates';
import { Badge } from '@/components/ui/badge';

export default {
  components: {
    Badge,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showBody: false,
    };
  },
  methods: {
    ...DateUtility,
    sanitize(html) {
      return sanitizeRichText(html);
    },
  },
};
</script>
